import styled from '@emotion/styled';

export const Spaced = styled.span({
  letterSpacing: '.15rem',
});
